module.exports = __webpack_public_path__ + "img/comida-china.d2e7d7f9.jpg";